import app from '../app';

/**
 * Сервис для интерсептора ошибок
 */
app.service('httpResponseErrorService', [function() {
    let skipCallbacks = [];

    /**
     * Добавляет в массив функцию, по которой может быть пропущена ошибка сервера
     * @param {Function} callback принимает один аргумент - конфиг запроса
     */
    this.addToSkip = (callback) => {
        angular.isFunction(callback) && skipCallbacks.push(callback);

        return () => {
            skipCallbacks = skipCallbacks.filter(i => i !== callback);
        };
    };

    /**
     * Принимает на вход конфиг запроса, и если есть хотя бы один колбек,
     * который вернет true(пропустить ошибку), то ошибка будет пропущена в interceptor'e
     * @param  {angularHttpRequestConfig} config конфиг, приходит от ангуляра
     * @return {bool} true если нужно пропустить ошибку
     */
    this.omitErrorNotification = (config) => {
        return skipCallbacks.some(callback => callback.call(null, config));
    };
}]);
